export default "static/media/destagnate.28e2e23.svg"